export const formatMoney = (valor) => {
  if (!valor) return valor
  var valorFormatado = Number(valor).toFixed(2).replace(".", ",");
  return "R$ " + valorFormatado.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

export const formatMoneySemR$ = (valor) => {
  var valorFormatado = Number(valor).toFixed(2).replace(".", ",");
  return valorFormatado.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}